import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const KPIService = {
  getKPI: async (params, instance) => {
    try {
      return (await apiClient.post('/fetchkpiData',params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },
};

export default KPIService;
